const withFields = fields => newFields => ({ ...fields, ...newFields })

export default withFields



// WEBPACK FOOTER //
// ./src/contentSchema/withFields.js